import {
    MOBILE_BRANDING,
    MOBILE_BRANDING_KEYS,
} from '../constants/mobileBrandingConst';
import BRANDING_CSS_VARS from '../constants/brandingCSSVarsConst';
import { getAttributeData } from './brandingUtil';

export const getPrimaryBgColor = (attributes) => {
    const { MOBILE_GLOBAL_PRIMARY_BG_COLOR } = MOBILE_BRANDING;

    const { value: primaryBgColor } = getAttributeData(
        attributes,
        MOBILE_BRANDING_KEYS[MOBILE_GLOBAL_PRIMARY_BG_COLOR],
    );

    return primaryBgColor;
};

const getSecondaryBgColor = (attributes) => {
    const { MOBILE_GLOBAL_SECONDARY_BG_COLOR } = MOBILE_BRANDING;

    const { value: secondaryBgColor } = getAttributeData(
        attributes,
        MOBILE_BRANDING_KEYS[MOBILE_GLOBAL_SECONDARY_BG_COLOR],
    );

    return secondaryBgColor;
};

const getShouldUseSecondaryBtnColors = (attributes) => {
    const { MOBILE_GLOBAL_BTN_IS_SECONDARY_COLOR } = MOBILE_BRANDING;

    const { value: shouldUseSecondaryBtnColors } = getAttributeData(
        attributes,
        MOBILE_BRANDING_KEYS[MOBILE_GLOBAL_BTN_IS_SECONDARY_COLOR],
    );

    return shouldUseSecondaryBtnColors;
};

const getBackgroundColorTheme = (attributes) => {
    const { MOBILE_GLOBAL_PRIMARY_BG_COLOR } = MOBILE_BRANDING;

    const bgColorTheme = {};
    const primaryBgColor = getPrimaryBgColor(attributes);

    bgColorTheme[
        BRANDING_CSS_VARS[MOBILE_GLOBAL_PRIMARY_BG_COLOR]
    ] = primaryBgColor;

    return bgColorTheme;
};

const getButtonTheme = (attributes) => {
    const { MOBILE_GLOBAL_BTN_BG_COLOR } = MOBILE_BRANDING;

    const buttonTheme = {};
    const primaryBgColor = getPrimaryBgColor(attributes);
    const secondaryBgColor = getSecondaryBgColor(attributes);
    const shouldUseSecondaryColors = getShouldUseSecondaryBtnColors(attributes);

    buttonTheme[
        BRANDING_CSS_VARS[MOBILE_GLOBAL_BTN_BG_COLOR]
    ] = shouldUseSecondaryColors ? secondaryBgColor : primaryBgColor;

    return buttonTheme;
};

const getTextColorTheme = (attributes) => {
    const {
        MOBILE_GLOBAL_PRIMARY_TEXT_COLOR,
        MOBILE_GLOBAL_SECONDARY_TEXT_COLOR,
    } = MOBILE_BRANDING;

    const textColorTheme = {};
    const { value: primaryTextColor } = getAttributeData(
        attributes,
        MOBILE_BRANDING_KEYS[MOBILE_GLOBAL_PRIMARY_TEXT_COLOR],
    );
    const { value: secondaryTextColor } = getAttributeData(
        attributes,
        MOBILE_BRANDING_KEYS[MOBILE_GLOBAL_SECONDARY_TEXT_COLOR],
    );
    const shouldUseSecondaryColors = getShouldUseSecondaryBtnColors(attributes);

    textColorTheme[
        BRANDING_CSS_VARS[MOBILE_GLOBAL_PRIMARY_TEXT_COLOR]
    ] = shouldUseSecondaryColors ? secondaryTextColor : primaryTextColor;

    return textColorTheme;
};

const mobileThemeUtil = (attributes) => {
    return {
        ...getBackgroundColorTheme(attributes),
        ...getButtonTheme(attributes),
        ...getTextColorTheme(attributes),
    };
};

export default mobileThemeUtil;
